import React from 'react'

import { Box } from 'components/_new/layout'
import Sidebar from 'components/smartSearch/Sidebar/Sidebar'
import SubscriptionBlock from 'components/smartSearch/SubscriptionBlock/SubscriptionBlock'

import CategoryLinks from './CategoryLinks/CategoryLinks'
import BrandLinks from './BrandLinks/BrandLinks'
import GenderLinks from './GenderLinks/GenderLinks'
import OtherLinks from './OtherLinks/OtherLinks'


type SEOSidebarProps = {
  fullWidth?: boolean
}


const SEOSidebar: React.FunctionComponent<SEOSidebarProps> = ({ fullWidth }) => (
  <Sidebar fullWidth={fullWidth}>
    <SubscriptionBlock />
    <Box mt={20}>
      <CategoryLinks />
    </Box>
    <Box mt={20}>
      <BrandLinks />
    </Box>
    <Box mt={20}>
      <GenderLinks />
    </Box>
    <Box mt={20}>
      <OtherLinks />
    </Box>
  </Sidebar>
)


export default SEOSidebar
